import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { GridCompatibilityService } from '../services/grid-compatibility.service';
import { ErrorService } from '../../services/error/error.service';
import { FileService } from '../../services/file.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { EnvironmentService } from '../../services/environment.service';
import { GridCompatibilityOrderProcessService } from '../services/grid-compatibility-order-process.service';
import { PersonalDataFormComponent } from '../../+grid-application-shared/components/personal-data-form/personal-data-form.component';
import { GridCompatibilityProcessStatus } from '../entities/enums/gridCompatibilityProcessStatus';
import { GridCompFeedInApplication } from '../entities/gridCompFeedInApplication';
import { GridCompatibilityCommentsService } from '../services/grid-compatibility-comments.service';
import { CommunicationService } from '../../services/communication.service';
import { NavigationStateShareService } from 'src/app/services/navigation-state-share.service';

@Component({
  selector: 'app-personal-data-form',
  templateUrl: '../../+grid-application-shared/components/personal-data-form/personal-data-form.component.html',
  styleUrls: ['./grid-comp-personal-data-form.component.scss'],
})
export class GridCompPersonalDataFormComponent extends PersonalDataFormComponent<GridCompFeedInApplication> {
  constructor(
    commonService: CommonService,
    router: Router,
    route: ActivatedRoute,
    service: GridCompatibilityService,
    commentService: GridCompatibilityCommentsService,
    errorService: ErrorService,
    fileService: FileService,
    localStorageService: LocalStorageService,
    cdRef: ChangeDetectorRef,
    environmentService: EnvironmentService,
    communicationService: CommunicationService,
    zone: NgZone,
    navigationStateShareService: NavigationStateShareService,
    private orderProcessService: GridCompatibilityOrderProcessService
  ) {
    super(
      commonService,
      router,
      route,
      service,
      commentService,
      errorService,
      fileService,
      localStorageService,
      cdRef,
      environmentService,
      communicationService,
      zone,
      navigationStateShareService
    );

    this.applicationTypeText = 'grid-comp.grid-comp-assessment';
  }

  protected loadOrderProcess(): void {
    this.preventLeak(this.orderProcessService.orderProcess$).subscribe(orderProcess =>
      this.setEditabilityBasedOnProcessStatus(orderProcess.status)
    );

    this.orderProcessService.loadOrderProcess(this.application_id);
  }

  private setEditabilityBasedOnProcessStatus(gridCompProcessStatus: GridCompatibilityProcessStatus): void {
    const externalRoleEditableStatuses = [GridCompatibilityProcessStatus.OpenIssue];
    const internalRoleEditableStatuses = [GridCompatibilityProcessStatus.RequestUpdated, GridCompatibilityProcessStatus.RequestSent];

    this.editabilityBasedOnProcessStatus.technicianRole = externalRoleEditableStatuses.includes(gridCompProcessStatus);
    this.editabilityBasedOnProcessStatus.customerRole = externalRoleEditableStatuses.includes(gridCompProcessStatus);
    this.editabilityBasedOnProcessStatus.internalRoles = internalRoleEditableStatuses.includes(gridCompProcessStatus);
  }
}
